import { Immutable } from "immer";
import React from "react";

import type { FeatureBlock as Value } from "@reactivated";

import { RichTextBlock } from "@thelabnyc/thelabui/src/components/RichText";

import { getSpacingClasses } from "../spacing";

type Props = Immutable<{
    value: Value;
}>;

export const FeatureBlock = (props: Props): React.JSX.Element => {
    const v = props.value;
    const image = v.image;
    // The legacy template rendered `{% image value.image width-750 %}`, which
    // emits a self-contained <img> using the width-750 rendition's url and
    // dimensions, with alt resolved to the image's default alt text. Read the
    // rendition directly (the block declares the width-750 rendition).
    const rendition = image?.renditions["width-750"];
    const link = v.link;
    return (
        <>
            {image && (
                <img
                    alt={image.default_alt_text}
                    src={rendition?.url}
                    width={rendition?.width}
                    height={rendition?.height}
                    loading="lazy"
                    decoding="async"
                />
            )}
            {/* The legacy wrapper <div> carries ONLY the spacing classes (no
                base class); with no spacing configured getSpacingClasses
                returns "" and React emits class="" — matching the server. */}
            <div className={getSpacingClasses(v.spacing)}>
                <RichTextBlock value={v.rich_text ?? ""} />
                {link?.display_name && (
                    <a
                        href={link.page?.url ?? link.external_url ?? "#"}
                        className={link.is_button ? "button" : undefined}
                    >
                        {link.display_name}
                    </a>
                )}
            </div>
        </>
    );
};
